import { Workbook } from 'exceljs';

export async function generateDownloadFile(): Promise<Workbook> {
  const header = ['First Name', 'Last Name', 'Company Email', 'Company Name'];

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Clients Data');

  // Add Header Row
  const headerRow = worksheet.addRow(header);

  // Style Header Row
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFFFF' },
      bgColor: { argb: 'FF248384' },
    };

    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };

    cell.font = {
      size: 14,
      bold: true,
    };
  });

  // Set column widths and styles
  worksheet.columns = header.map(() => ({
    width: 30,
    style: { font: { size: 12 } },
  }));

  // Set zoom and row height
  worksheet.views = [
    {
      zoomScale: 90,
    },
  ];
  worksheet.properties.defaultRowHeight = 20;

  return workbook;
}